import { ReactElement, useState } from "react";
import { GenericNavigationPanelProps, SubNavigation } from "../SubNavigation";
import { localize } from "client_legacy/ndaw/culture";
import { useShouldStartLoadingData } from "./useShouldStartLoadingData";
import { AppType } from "client/Api/Apps/common";
import { DocumentStructure } from "./DocumentStructure/DocumentStructure";

type DocumentsPanelProps = GenericNavigationPanelProps;

export const DocumentPanel = (props: DocumentsPanelProps): ReactElement | null => {
	const {
		isVisible,
		isPinned,
		isActive
	} = props;

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const shouldStartLoadingData: boolean = useShouldStartLoadingData(isPinned, isVisible);
	const isRenderedByPage: boolean = isActive;

	if (isRenderedByPage) {
		return null;
	}

	const renderContent = (): ReactElement | null => {
		if (!shouldStartLoadingData) {
			return <SubNavigation.LoadingIndicator />;
		}

		return (
			<>
				{isLoading && <SubNavigation.LoadingIndicator />}
				<DocumentStructure onIsLoadingChange={setIsLoading} />
			</>
		);
	};

	return (
		<>
			<SubNavigation.Header
				kind={AppType.Documents}
				title={localize("_Documents")}
			/>
			<SubNavigation.Body>
				{renderContent()}
			</SubNavigation.Body>
		</>
	);
};

DocumentPanel.displayName="DocumentPanel";